import { ICharacterOutlineByUser } from '../../../../../interfaces/book.interface';
import { StoryCharacterAgeUnitEnum, StoryCharacterEnum } from '../../../../../interfaces/character.interface';

interface UseCharacterOutlineProps {
  characterOutlineByUser: ICharacterOutlineByUser;
  setCharacterOutlineByUser: React.Dispatch<React.SetStateAction<ICharacterOutlineByUser>>;
}

const setCharacterOutline = ({
                               characterOutlineByUser,
                               setCharacterOutlineByUser,
                             }: UseCharacterOutlineProps) => {
  if (!characterOutlineByUser?.ageUnit) {
    setCharacterOutlineByUser((prevState: ICharacterOutlineByUser) => ({
      ...prevState,
      ageUnit: StoryCharacterAgeUnitEnum.year
    }));
  }
  if (
    !characterOutlineByUser?.characterType ||
    characterOutlineByUser.characterType === StoryCharacterEnum.human
  ) {
    setCharacterOutlineByUser((prevState: ICharacterOutlineByUser) => ({
      ...prevState,
      characterType: StoryCharacterEnum.human,
      character: StoryCharacterEnum.human
    }));
  }
};

export default setCharacterOutline;
